import React from 'react';
import Button from '../../ui/Button';
import Input from '../../ui/Input';
import USDateInput from '../../ui/USDateInput';
import './CreateTournamentModal.css';

const CreateTournamentModal = ({
  showCreateModal,
  setShowCreateModal,
  tournamentForm,
  setTournamentForm,
  handleCreateTournament,
  createTournamentMutation,
  resetForm
}) => {
  if (!showCreateModal) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2>Create New Tournament</h2>
          <button
            onClick={() => {
              setShowCreateModal(false);
              resetForm();
            }}
            className="modal-close"
          >
            ×
          </button>
        </div>
        
        <form onSubmit={(e) => {
          e.preventDefault();
          
          // Validate form data
          if (!tournamentForm.name || !tournamentForm.startDate || !tournamentForm.endDate || !tournamentForm.maxPlayers) {
            alert('Please fill in all required fields');
            return;
          }
          
          // Validate that end date is after start date
          const startDate = new Date(tournamentForm.startDate + 'T00:00:00');
          const endDate = new Date(tournamentForm.endDate + 'T00:00:00');
          
          if (endDate <= startDate) {
            alert('End date must be after start date');
            return;
          }
          
          // Ensure start date is not in the past (allow today)
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          
          if (startDate < today) {
            alert('Start date cannot be in the past');
            return;
          }
          
          // Prepare data for submission (set time to start/end of day)
          const startDateTime = new Date(tournamentForm.startDate + 'T00:00:00');
          
          const endDateTime = new Date(tournamentForm.endDate + 'T23:59:59.999Z');
          
          const submissionData = {
            name: tournamentForm.name,
            description: tournamentForm.description || '',
            startDate: startDateTime.toISOString(),
            endDate: endDateTime.toISOString(),
            maxPlayers: parseInt(tournamentForm.maxPlayers, 10),
            rules: tournamentForm.rules || ''
          };
          
          console.log('Submitting tournament data:', submissionData);
          
          handleCreateTournament(submissionData);
        }} className="tournament-form">
          <div className="form-row">
            <div className="create-tournament-form-group">
              <label htmlFor="name">Tournament Name *</label>
              <Input
                id="name"
                type="text"
                value={tournamentForm.name}
                onChange={(e) => setTournamentForm({...tournamentForm, name: e.target.value})}
                required
              />
            </div>
            
            <div className="create-tournament-form-group">
              <label htmlFor="status">Status *</label>
              <select
                id="status"
                value={tournamentForm.status}
                onChange={(e) => setTournamentForm({...tournamentForm, status: e.target.value})}
                required
              >
                <option value="DRAFT">Draft</option>
                <option value="ACTIVE">Active</option>
                <option value="COMPLETED">Completed</option>
                <option value="CANCELLED">Cancelled</option>
              </select>
            </div>
          </div>

          <div className="create-tournament-form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              value={tournamentForm.description}
              onChange={(e) => setTournamentForm({...tournamentForm, description: e.target.value})}
              rows="3"
            />
          </div>

          <div className="form-row">
            <div className="create-tournament-form-group">
              <label htmlFor="startDate">Start Date * (MM/DD/YYYY)</label>
              <USDateInput
                id="startDate"
                value={tournamentForm.startDate}
                onChange={(e) => setTournamentForm({...tournamentForm, startDate: e.target.value})}
                required
              />
            </div>
            
            <div className="create-tournament-form-group">
              <label htmlFor="endDate">End Date * (MM/DD/YYYY)</label>
              <USDateInput
                id="endDate"
                value={tournamentForm.endDate}
                onChange={(e) => setTournamentForm({...tournamentForm, endDate: e.target.value})}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="create-tournament-form-group">
              <label htmlFor="maxPlayers">Max Players *</label>
              <Input
                id="maxPlayers"
                type="number"
                min="1"
                value={tournamentForm.maxPlayers}
                onChange={(e) => setTournamentForm({...tournamentForm, maxPlayers: e.target.value})}
                required
              />
            </div>
          </div>


          <div className="create-tournament-form-group">
            <label htmlFor="rules">Tournament Rules</label>
            <textarea
              id="rules"
              value={tournamentForm.rules}
              onChange={(e) => setTournamentForm({...tournamentForm, rules: e.target.value})}
              rows="4"
              placeholder="Enter tournament rules and regulations..."
            />
          </div>

          <div className="form-actions">
            <Button
              type="button"
              onClick={() => {
                setShowCreateModal(false);
                resetForm();
              }}
              className="cancel-btn"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="submit-btn"
              disabled={createTournamentMutation.isLoading}
            >
              {createTournamentMutation.isLoading ? 'Creating...' : 'Create Tournament'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateTournamentModal;
